
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDTVK5a6KA_sDuFNGwZ4rNvk4tV-mWx3L4",
  authDomain: "pocketprof-educatortoolkit.firebaseapp.com",
  projectId: "pocketprof-educatortoolkit",
  storageBucket: "pocketprof-educatortoolkit.firebasestorage.app",
  messagingSenderId: "709558169521",
  appId: "1:709558169521:web:1a04851892b4ff82999790",
  measurementId: "G-0V20ZNG31L"
};

const app = initializeApp(firebaseConfig);

const isLocalhost = typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// If on localhost, assign the debug token so the Firebase client SDK uses it.
// If you put your registered token in VITE_APPCHECK_DEBUG_TOKEN, we use that.
// Otherwise, setting it to true will generate a new one and log it to your console.
if (isLocalhost && typeof window !== 'undefined') {
  (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = import.meta.env.VITE_APPCHECK_DEBUG_TOKEN || true;
}

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || "6Lf6EYYtAAAAAMzFTd916NknsiPX_A437cNeOQbd";

// Initialize App Check for both localhost (using debug token) and production (using reCAPTCHA)
if (typeof window !== 'undefined') {
  if (isLocalhost || RECAPTCHA_SITE_KEY) {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
  } else {
    console.warn("⚠️ App Check reCAPTCHA site key is missing. Firebase requests may be blocked.");
  }
}


export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const microsoftProvider = new OAuthProvider('microsoft.com');

// Initialize Cloud Firestore and get a reference to the service with persistent cache
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
}, 'toronto-db');

// Initialize and connect Functions Emulator for local development
export const functions = getFunctions(app, 'northamerica-northeast1');
if (typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}

